export const PROACTIVE_TOKEN_REFRESH_THRESHOLD_MILLISECONDS = 2 * 60 * 1000;
